import { Button } from 'evergreen-ui'
import { Link as RouterLink } from 'react-router-dom'
import * as React from 'react'
import { useBreakpoint } from '/fiweb/lib'

interface Props {
  campaignToolMode?: boolean
  visitorIsApprovedForPreorder?: boolean
  url: string
}

export const PreorderButton = ({ campaignToolMode, visitorIsApprovedForPreorder, url }: Props) => {
  const { medium } = useBreakpoint()

  if (campaignToolMode || !visitorIsApprovedForPreorder) {
    return null
  }

  return (
    <Button
      is={RouterLink}
      to={url}
      appearance='primary'
      borderRadius={40}
      size={medium ? 'small' : 'large'}
      fontSize={medium ? 16 : 17}
      width='100%'
    >
      Forhåndstegn aksjer
    </Button>
  )
}
